export default "__VITE_ASSET__a2fffbc0__"